import * as actions from './account.actions';
import reducer from './account.reducer';

export const getAccountDefaults = () => ({
	email: '',
	password: '',
	passwordConfirm: '',
})

const accountModule = { actions, reducer };

export default accountModule;

export { actions, reducer };


// WEBPACK FOOTER //
// ./src/modules/account/account.module.js